import { About } from '../components/About';

export const aboutRoute = {
  name: 'about',
  path: '/about',
  exact: true,
  component: About,
  resources: [],
};
